import React, { createContext, useContext, useMemo } from "react";

type ContextState = {
  authenticatedRouteType?: AuthenticatedRoutetype;
};

type AuthenticatedRoutetype = "user" | "actor" | null;

const SystemContext = createContext<ContextState | undefined>(undefined);

export function AuthenticatedRouteProvider({
  type,
  children,
}: {
  type: AuthenticatedRoutetype;
  children: React.ReactNode;
}) {
  const memoizedValue = useMemo(() => {
    return {
      authenticatedRouteType: type,
    };
  }, [type]);

  return <SystemContext.Provider value={memoizedValue}>{children}</SystemContext.Provider>;
}

export function useAuthenticatedRoute() {
  const context = useContext(SystemContext);
  if (context === undefined) {
    throw new Error("useAuthenticatedRoute must be used within an AuthenticatedRouteProvider");
  }

  return context;
}
